const AddCommentIcon = () => (
  <svg
    width='28px'
    height='28px'
    viewBox='0 0 28 28'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Add Comment</title>
    <g
      id='Comments'
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g
        id='Group'
        transform='translate(4.000000, 5.000000)'
      >
        <path
          d='M10.3523926,3.26330566 L10.3514341,6.75730566 L13.8473511,6.75826416 L13.8473511,8.05826416 L10.3514341,8.05730566 L10.3523926,11.5532227 L9.05239258,11.5532227 L9.05143408,8.05730566 L5.55743408,8.05826416 L5.55743408,6.75826416 L9.05143408,6.75730566 L9.05239258,3.26330566 L10.3523926,3.26330566 Z'
          id='Combined-Shape'
          fill='#000000'
          fillRule='nonzero'
        />
        <path
          d='M0,3 C-2.02906125e-16,1.34314575 1.34314575,3.04359188e-16 3,0 L17,0 C18.6568542,-3.04359188e-16 20,1.34314575 20,3 L20,12 C20,13.6568542 18.6568542,15 17,15 L3.236,15 L0.515392453,17.8067667 C0.473014105,17.8504787 0.418706818,17.879911 0.359955475,17.8918952 L0.3,17.897946 C0.134314575,17.897946 2.02906125e-17,17.7636314 0,17.597946 L0,17.597946 L0,3 Z'
          id='Combined-Shape'
          stroke='#000000'
          strokeWidth='1.5'
        />
      </g>
    </g>
  </svg>
)

export default AddCommentIcon
